import { gql } from "@apollo/client";

export const GET_NEWS_HEADER = gql`
  query getNewsHeader {
    page(id: "cG9zdDo0MTQy", idType: ID) {
      pageHeaderBlock {
        pageTitle
        pageDescription
        pageBackground {
          sourceUrl
          srcSet
        }
      }
    }
  }
`;
